import { memo, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import { getContactPageUrl } from '../../utils/getContactPageUrl';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Popover = styled.div.withConfig({
  displayName: "CRMEmbeddedMessage__Popover",
  componentId: "d2amrq-0"
})(["width:320px;margin-left:auto;margin-right:auto;"]);
const MessageWrapper = styled.div.withConfig({
  displayName: "CRMEmbeddedMessage__MessageWrapper",
  componentId: "d2amrq-1"
})(["text-align:center;padding-left:8px;padding-right:8px;margin-top:16px;margin-bottom:16px;"]);
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "CRMEmbeddedMessage__StyledFormattedMessage",
  componentId: "d2amrq-2"
})(["font-weight:600;margin-bottom:16px;margin-top:0;display:block;font-size:20px;line-height:normal;"]);
function CRMEmbeddedMessage({
  subjectId,
  objectTypeId
}) {
  useEffect(() => {
    // @ts-expect-error Property 'wordpress' does not exist on type ...
    const isUsingWordPress = window.hubspot && window.hubspot.wordpress;
    if (isUsingWordPress) {
      CommunicatorLogger.log('callingInteraction', {
        action: 'WordPress user: click call icon'
      });
    }
  }, []);
  return /*#__PURE__*/_jsx(Popover, {
    children: /*#__PURE__*/_jsxs(MessageWrapper, {
      children: [/*#__PURE__*/_jsx(StyledFormattedMessage, {
        message: "crmEmbeddedMessage.title"
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "crmEmbeddedMessage.body_jsx",
        elements: {
          UILink
        },
        options: {
          href: getContactPageUrl(subjectId, objectTypeId),
          target: '_blank',
          rel: 'noopener noreferrer'
        }
      })]
    })
  });
}
export default /*#__PURE__*/memo(CRMEmbeddedMessage);